
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Systeminahmedabad() {



  const cardData =
  {
    keyword: 'Patient Thermoregulation System in Ahmedabad',
    heading: 'Pharmacle Health Care Private Limited: Patient Thermoregulation System in Ahmedabad',
    headingDescription: 'Pharmacle Health Care Private Limited offers advanced Patient Thermoregulation Systems in Ahmedabad, designed to maintain optimal body temperature during surgeries and critical care. Our Wallabies Warm Care systems ensure uniform and efficient warming, reducing the risk of hypothermia and enhancing patient recovery. Trusted by hospitals and healthcare professionals, our thermoregulation systems are safe, reliable, and easy to use. With cutting-edge technology and superior quality, we help improve patient outcomes. Choose Pharmacle Health Care for the best patient thermoregulation solutions in Ahmedabad.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
  {
    "title": "Advanced Patient Thermoregulation System in Ahmedabad",
    "description": "Pharmacle Health Care provides high-performance Patient Thermoregulation Systems in Ahmedabad, designed to maintain precise body temperature control during surgeries, ICU care, and recovery. These systems help prevent hypothermia and ensure superior clinical outcomes."
  },
  {
    "title": "Forced Air Thermoregulation System for Hospitals in Ahmedabad",
    "description": "Our Forced Air Thermoregulation System offers effective heat distribution to prevent hypothermia in operating rooms and critical care units. Trusted by Ahmedabad’s healthcare providers, it ensures patient safety and comfort."
  },
  {
    "title": "Portable Thermoregulation Device for Emergency Care",
    "description": "Lightweight and efficient, our Portable Thermoregulation Device is ideal for ambulances, emergency rooms, and field hospitals in Ahmedabad. It provides rapid warming support for critical patients during transport or urgent care."
  },
  {
    "title": "Neonatal Thermoregulation System for NICUs in Ahmedabad",
    "description": "Specially designed for newborns, our Neonatal Thermoregulation System ensures gentle and precise thermal regulation in NICUs and maternity wards. Pharmacle Health Care supports neonatal safety and healthy recovery."
  },
  {
    "title": "ICU Patient Thermoregulation System for Critical Care",
    "description": "Pharmacle Health Care offers advanced ICU Patient Thermoregulation Systems in Ahmedabad, helping critically ill patients maintain normothermia. These systems improve recovery rates and minimize temperature-related complications."
  },
  {
    "title": "Surgical Thermoregulation Equipment for Ahmedabad Hospitals",
    "description": "Our Surgical Thermoregulation Equipment ensures stable patient body temperature throughout procedures. Essential for operating rooms, it reduces perioperative hypothermia risks and supports successful outcomes."
  },
  {
    "title": "Preoperative & Postoperative Warming Systems",
    "description": "Pharmacle Health Care provides effective Preoperative and Postoperative Warming Systems in Ahmedabad. These systems offer continuous warming before and after surgeries, reducing recovery time and preventing complications."
  },
  {
    "title": "Veterinary Thermoregulation Systems for Clinics in Ahmedabad",
    "description": "Our Veterinary Thermoregulation Systems provide safe and reliable temperature control for pets and livestock undergoing medical treatments and surgeries. Trusted by veterinary clinics in Ahmedabad."
  },
  {
    "title": "Emergency Patient Warming Systems for Trauma Care",
    "description": "Ideal for emergency and trauma situations, our Emergency Patient Warming Systems rapidly stabilize body temperature in critical cases. Pharmacle Health Care ensures better survival and recovery outcomes in Ahmedabad."
  },
  {
    "title": "Disposable Warming Blankets for Infection-Free Care",
    "description": "Pair our thermoregulation systems with Disposable Warming Blankets for a hygienic and effective warming solution. Designed for hospitals and clinics in Ahmedabad, these blankets help minimize cross-contamination risks."
  }
],


"services": [
    {
        "name": "Patient Thermoregulation System Ahmedabad",
        "description": "Pharmacle Health Care Private Limited offers advanced patient thermoregulation systems in Ahmedabad, designed to maintain a stable body temperature during medical treatments, preventing hypothermia and ensuring patient safety throughout surgeries and recovery."
    },
    {
        "name": "Ahmedabad Patient Warming Devices",
        "description": "We provide high-quality patient warming devices in Ahmedabad, designed to regulate and maintain optimal body temperature during medical procedures. Our devices help prevent hypothermia and improve patient comfort in critical care and recovery."
    },
    {
        "name": "Forced Air Warming Systems Ahmedabad",
        "description": "Pharmacle Health Care offers forced air warming systems in Ahmedabad, providing a reliable solution to maintain patient body temperature during surgeries and post-operative care, ensuring safety and comfort throughout the treatment."
    },
    {
        "name": "Thermoregulation Devices Ahmedabad",
        "description": "We supply thermoregulation devices in Ahmedabad that are essential for temperature management during medical procedures. Our devices effectively regulate body temperature to ensure a stable and safe environment for patients."
    },
    {
        "name": "Patient Warming System Supplier Ahmedabad",
        "description": "Pharmacle Health Care is a trusted supplier of patient warming systems in Ahmedabad, offering high-quality equipment designed to maintain optimal patient body temperature during surgeries, critical care, and recovery."
    },
    {
        "name": "Ahmedabad Medical Warming Equipment",
        "description": "Our medical warming equipment in Ahmedabad is designed to ensure patient safety by regulating body temperature during surgeries and medical procedures. We provide effective solutions for hospitals and healthcare providers to improve patient care."
    },
    {
        "name": "Patient Temperature Management Ahmedabad",
        "description": "Pharmacle Health Care offers patient temperature management solutions in Ahmedabad, including warming systems and thermoregulation devices that help control and stabilize patient body temperature during medical procedures to ensure a safe and comfortable experience."
    }
],
"tableData": [
    ["- Patient Thermoregulation System Ahmedabad", "- Ahmedabad Patient Warming Devices"],
    ["- Forced Air Warming Systems Ahmedabad", "- Thermoregulation Devices Ahmedabad"],
    ["- Patient Warming System Supplier Ahmedabad", "- Ahmedabad Medical Warming Equipment"],
    ["- Patient Temperature Management Ahmedabad"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient thermoregulation systems in Ahmedabad, designed to provide precise control of body temperature during medical procedures. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics throughout Ahmedabad."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a comprehensive range of patient thermoregulation systems in Ahmedabad, including forced air warming devices and temperature control blankets. Our solutions are tailored to meet the needs of both surgical procedures and critical care, ensuring that your patients remain comfortable and safe during their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient thermoregulation equipment is manufactured to the highest quality standards, ensuring long-lasting performance and durability. Our systems undergo rigorous testing and regular servicing to ensure optimal reliability for continuous use in medical settings in Ahmedabad."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our thermoregulation systems provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring patients in Ahmedabad are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient thermoregulation systems are adaptable to various healthcare settings in Ahmedabad, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care's patient thermoregulation systems are designed for seamless integration with existing medical systems in Ahmedabad. Our products can be quickly implemented, ensuring a smooth and efficient experience for healthcare professionals without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services in Ahmedabad to help healthcare facilities choose the right thermoregulation solutions for their needs. Our team also provides ongoing support and maintenance services to ensure that your equipment remains in optimal condition and performs at its best."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are central to our mission. Our thermoregulation systems are designed to prevent temperature-related issues during critical medical procedures, ensuring every patient in Ahmedabad receives the highest standard of care."
    }
]






  }


  const faqData = [
    { question: "What is a Patient Thermoregulation System?", answer: "A Patient Thermoregulation System is a medical device designed to maintain or regulate a patient's body temperature during medical procedures by using temperature-controlled air, blankets, or other warming mechanisms." },
    { question: "How does the Patient Thermoregulation System work?", answer: "The system works by circulating warm air through a special warming blanket or pad, helping to stabilize and regulate the patient's body temperature during surgeries or medical treatments." },
    { question: "Is the Patient Thermoregulation System available in Ahmedabad?", answer: "Yes, Pharmacle Health Care Private Limited offers the Patient Thermoregulation System in Ahmedabad, ensuring healthcare facilities have access to reliable temperature management solutions." },
    { question: "What are the benefits of using a Patient Thermoregulation System?", answer: "The benefits include preventing hypothermia, reducing surgical complications, enhancing patient comfort, speeding up recovery, and improving overall clinical outcomes." },
    { question: "How long does the Patient Thermoregulation System maintain the patient's body temperature?", answer: "The system can maintain the patient’s body temperature for the entire duration of the medical procedure, adjusting as necessary to ensure stable warmth." },
    { question: "Is the Patient Thermoregulation System easy to use?", answer: "Yes, it is designed with user-friendly controls, allowing healthcare professionals to easily monitor and adjust settings to provide the ideal temperature for the patient." },
    { question: "Can the Patient Thermoregulation System be used in all types of surgeries?", answer: "Yes, the system is versatile and can be used in a variety of surgeries and medical procedures, particularly those where temperature regulation is essential for patient safety." },
    { question: "Is the Patient Thermoregulation System safe for all patients?", answer: "Yes, the system is safe for most patients. However, it should always be used according to the manufacturer’s guidelines and under the supervision of trained healthcare professionals." },
    { question: "How can I purchase a Patient Thermoregulation System in Ahmedabad?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with the purchase and delivery process for Ahmedabad." },
    { question: "Does Pharmacle Health Care offer support for the Patient Thermoregulation System?", answer: "Yes, we offer complete support for the Patient Thermoregulation System, including installation, training for healthcare staff, and ongoing maintenance services to ensure reliable performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We’ve been using the Patient Thermoregulation System from Pharmacle Health Care in our Ahmedabad hospital, and it has helped us provide better care by ensuring patients stay at an optimal body temperature during surgeries.',
      name: 'Dr. Mehul Patel',
    },
    {
      text: 'The Patient Thermoregulation System from Pharmacle Health Care has significantly improved patient comfort and safety in our Ahmedabad clinic. It’s easy to use and effective for maintaining normothermia during procedures.',
      name: 'Dr. Rina Shah',
    }
  ];
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Thermoregulation System in Ahmedabad",
    "description": "Explore high-quality Patient Thermoregulation Systems in Ahmedabad for effective temperature management and patient warming. Our systems ensure optimal patient comfort and safety during medical procedures and surgeries.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1190"
    }
  };
  



  return (
    <div>
  <Helmet>
    <title>Patient Thermoregulation System in Ahmedabad | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore high-quality Patient Thermoregulation Systems in Ahmedabad for patient warming and temperature management. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Thermoregulation System Ahmedabad, Ahmedabad Patient Warming Devices, Forced Air Warming Systems Ahmedabad, Thermoregulation Devices Ahmedabad, Patient Warming System Supplier Ahmedabad, Ahmedabad Medical Warming Equipment, Patient Temperature Management Ahmedabad"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/7.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Systeminahmedabad;